import { Paper, Table } from "@mantine/core";
import { formatNumberAsCurrencyString, formatNZD } from "common/utils";
import React from "react";
import { ProductManagementChildFormProps } from "types/interface.types";
/**
 * Product Sales Figures
 * @param param0
 * @returns
 */
const ProductDetailsCard3: React.FC<ProductManagementChildFormProps> = ({
  readonly,
  formApi,
}) => {
  const { values, setFieldValue } = formApi;

  return (
    <div className="card-container ">
      <Paper
        radius="md"
        shadow="md"
        withBorder
        style={{
          overflow: "hidden",
          maxHeight: "60vh",
          background: "white",
        }}
      >
        <Table style={{ tableLayout: "fixed", width: "100%" }}>
          <colgroup>
            <col style={{ width: "20%" }} />
            <col style={{ width: "40%" }} />
            <col style={{ width: "40%" }} />
          </colgroup>

          <Table.Thead>
            <Table.Tr>
              <Table.Th>&nbsp;</Table.Th>
              <Table.Th className="number">Month to Date (MTD)</Table.Th>
              <Table.Th className="number">Year To Date (YTD)</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            <Table.Tr>
              <Table.Th>Sales</Table.Th>
              <Table.Td className="number">
                {formatNZD(values.salesMtd)}
              </Table.Td>
              <Table.Td className="number">
                {formatNZD(values.salesYtd)}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>Cost</Table.Th>
              <Table.Td className="number">
                {formatNZD(values.costMtd)}
              </Table.Td>
              <Table.Td className="number">
                {formatNZD(values.costYtd)}
              </Table.Td>
            </Table.Tr>
            <Table.Tr>
              <Table.Th>Quantity</Table.Th>
              <Table.Td className="number">
                {formatNumberAsCurrencyString(values.quanMtd, 0, 0)}
              </Table.Td>
              <Table.Td className="number">
                {formatNumberAsCurrencyString(values.quanYtd, 0, 0)}
              </Table.Td>
            </Table.Tr>
          </Table.Tbody>
        </Table>
      </Paper>
    </div>
  );
};
export default React.memo(ProductDetailsCard3);
